const MIN_DATE = new Date("01/01/2021");

const valueDateColumn = () => ({
	name: "valueDate",
	type: "date-picker" as const,
	placeholder: "Value Date",
	minDate: MIN_DATE,
});

export default valueDateColumn;
